interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-gray-200 ${className}`}
      aria-hidden="true"
    />
  );
}

export function SkeletonText({ className = "" }: SkeletonProps) {
  return <Skeleton className={`h-4 w-full ${className}`} />;
}

export function SkeletonCircle({ className = "" }: SkeletonProps) {
  return <Skeleton className={`h-12 w-12 rounded-full ${className}`} />;
}

export function SkeletonCard({ className = "" }: SkeletonProps) {
  return <Skeleton className={`h-32 w-full rounded-lg ${className}`} />;
}
